import { render, staticRenderFns } from "./SupplierGalleryImagePicker.vue?vue&type=template&id=636a16e2&scoped=true&"
import script from "./SupplierGalleryImagePicker.vue?vue&type=script&lang=js&"
export * from "./SupplierGalleryImagePicker.vue?vue&type=script&lang=js&"
import style0 from "./SupplierGalleryImagePicker.vue?vue&type=style&index=0&id=636a16e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636a16e2",
  null
  
)

export default component.exports